import React from 'react';
import { motion } from 'framer-motion';
import { Pattern } from '../types';

interface PatternDisplayProps {
  pattern: Pattern;
  showHint: boolean;
  onToggleHint: () => void;
}

export const PatternDisplay: React.FC<PatternDisplayProps> = ({
  pattern,
  showHint,
  onToggleHint
}) => {
  const formatNumber = (num: number | string) => {
    if (typeof num === 'number') {
      return pattern.type === 'fraction' 
        ? `${Math.floor(num * 4)}/${4}`
        : num.toString();
    }
    return num;
  };

  return (
    <div className="bg-white/20 rounded-2xl p-8 text-center">
      <h2 className="text-3xl font-bold mb-6">Find the Pattern</h2>
      
      <div className="flex justify-center items-center space-x-6 mb-8">
        {pattern.sequence.map((num, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
            className={`
              w-20 h-20 rounded-xl flex items-center justify-center text-2xl font-bold
              ${num === '?' ? 'bg-white/10 text-3xl' : 'bg-white text-[#4558C8]'}
            `}
          >
            {formatNumber(num)}
          </motion.div>
        ))}
      </div>

      <button
        onClick={onToggleHint}
        className="bg-white/10 px-6 py-2 rounded-full hover:bg-white/20 transition-colors"
      >
        {showHint ? 'Hide Hint' : 'Show Hint'}
      </button>

      {showHint && (
        <motion.p
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="mt-4 text-lg"
        >
          Hint: {pattern.hint}
        </motion.p>
      )}
    </div>
  );
};